import { Activity } from "lucide-react";
import React from "react";

const RecentTransactions = ({ narratives = [] }) => {
  return (
    <div className="bg-content flex-1 shadow-lg border border-bkg2 rounded-lg p-3 text-text-1 overflow-auto">
      <div className="flex items-center justify-between mb-4">
        <h5 className="flex items-center gap-1.5 font-medium text-text-1/80">
          <Activity size={18} /> Recent Tasks
        </h5>
        <button className="text-sm text-primary hover:underline">
          See all
        </button>
      </div>
      <div className="table-container bg-content h-52 overflow-auto">
        <table>
          <thead>
            <tr className="text-sm font-normal text-text-1/65">
              <th className="text-start p-1.5">Id</th>
              <th className="text-start p-1.5">Name</th>
              <th className="text-start p-1.5">Date</th>
              <th className="text-start p-1.5">Activity</th>
              <th className="text-start p-1.5">Status</th>
              <th className="w-8"></th>
            </tr>
          </thead>
          <tbody>
            {narratives.map((item, index) => (
              <TableRow
                key={index}
                id={index + 1}
                date={item.created_at}
                name={`${item.sub_creator.first_name[0]}. ${item.sub_creator.last_name}`}
                activity={item.name}
                status="Completed"
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const TableRow = ({ id, name, date, activity, status }) => {
  return (
    <tr className="text-text-1/50">
      <td className="text-text-1/50">{id}</td>
      <td className="text-text-1/50">{name}</td>
      <td className="text-text-1/50">
        {date ? new Date(date).toDateString() : "N/A"}
      </td>
      <td className="text-text-1/50">{activity}</td>
      <td className="text-text-1/50">{status}</td>
      <td className="text-text-1/50"></td>
    </tr>
  );
};

export default RecentTransactions;
